module.exports = __webpack_public_path__ + "static/icons-acb0ccd87cdb2370cae479a1d243487b.svg";